import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg027DrawkitNotebookManColour = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "notebook-man-colour",
	viewBox: "0 0 1200 1200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".notebook-man-cls-1{fill:#d0d0d0}.notebook-man-cls-2{fill:#dedede}.notebook-man-cls-3{fill:#f3f3f3}.notebook-man-cls-4{fill:#de8e68}.notebook-man-cls-5{fill:#dfdfdf}" }) }),
		/* @__PURE__ */ _jsx("rect", {
			width: 467.4,
			height: 701.58,
			x: 211.6,
			y: 325.89,
			className: "notebook-man-cls-1",
			rx: 64.48,
			ry: 64.48,
			transform: "rotate(-10.49 445.53 677)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m151.6 374.34 328.24-60.78 127.73 689.86-328.25 60.78z",
			className: "notebook-man-cls-1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 514.9,
			height: 701.58,
			x: 182.21,
			y: 308.56,
			className: "notebook-man-cls-2",
			rx: 64.48,
			ry: 64.48,
			transform: "rotate(-14.68 439.8 659.48)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m101.68 385.3 355.74-93.2 177.8 678.68-355.75 93.2z",
			className: "notebook-man-cls-2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m469.74 291.64 47.53-12.25 175.4 680.53-47.54 12.25z",
			className: "notebook-man-cls-3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m175.7 457.39 402.43-105.43L625 530.92 222.58 636.35z",
			className: "notebook-man-cls-3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m175.7 457.39 402.43-105.43L625 530.92 222.58 636.35zM280.49 925.1l154.25-40.4 24.75 94.46-154.25 40.4z",
			className: "notebook-man-cls-3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M901 512.69c3.7 1.68 12.45 8.4 15.81 12.27 3.87-1.85 70.12-43.21 79.71-42.71s4.54 19.5 4.54 21.35-79.91 64.07-92.93 64.07-30.33-28.25-30.33-29.93 23.2-25.05 23.2-25.05",
			className: "notebook-man-cls-4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m1036.5 349.28-9.84-1.4-20-2.83-2.83 20-84 593.6-5.22 36.88a20.2 20.2 0 0 0 17.15 22.8l9.85 1.4a20.2 20.2 0 0 0 22.8-17.16l5.22-36.87 84-593.6 2.83-20Z",
			className: "notebook-man-cls-5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m1040.88 282.86-34.2 62.19 49.8 7.05z",
			className: "notebook-man-cls-3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m1046.02 305.68-5.14-22.82-11.27 20.49z",
			className: "notebook-man-cls-5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m920.6 952.7 49.8 7.05-2.53 17.88-49.8-7.06z",
			className: "notebook-man-cls-3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M840.05 995.14h24.24v14.61h-24.24zm57.57-34.8 13.16-17.9 11.77 8.64-13.16 17.9z",
			className: "notebook-man-cls-4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M748.2 685s-15.85 142.2-10.31 158.12 162 119.76 162 119.76l14.54-19.38-118.37-121.85c5.87-4.5 28.92-60.91 29.51-65.76s-17.07-80-17.07-80Z",
			style: { fill: "#56cad8" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M844.71 483.16c12.62-19.48 62 20.9 63.32 29.36s-18.88 41.77-34.75 40.93-35.92-58.95-28.57-70.29",
			style: { fill: "#fcc486" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M810.59 452.79c96.24 0 70.34 197.48 68.87 213.37C872.1 678.81 755.24 692.7 748.2 685c-2.94-22.08-28.55-232.21 62.39-232.21",
			style: { fill: "#fed385" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M801.68 462.5c0 5.58 30.9 6.77 30.9 0v-37.95h-30.9Z",
			className: "notebook-man-cls-4"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 821.82,
			cy: 408.31,
			className: "notebook-man-cls-4",
			rx: 27.68,
			ry: 37.2,
			transform: "rotate(-21.6 817.28 404.78)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 797.11,
			cy: 421.56,
			className: "notebook-man-cls-4",
			rx: 6.2,
			ry: 8.88,
			transform: "rotate(-35.61 797.1 421.56)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M771.13 403.75c0-5.16 4.81-10.83 5.72-17.31.47-3.28-.55-16.94 3.28-21.56 8-9.57 12.66-7.61 18.75-9.84 10.61-3.88 14.67-10.31 23.43-10.31 10 0 14 5.16 21.09 5.16 8.14 0 14.82-3.75 26.25-3.75 6.09 0 14.05 8 14.05 15 0 16.62-15.46 14.24-15.46 18.28 0 2.81.94 5 .94 8.91 0 5-6.56 8-10.31 8-11.42 0-12.94-1.39-12.94-1.39a54 54 0 0 0-8.6-12.44c-.46-.48-7.88 4.76-20 5.17-9.93.33-16.93 2.25-16.93 6.87 0 3.27 1.2 13 1.13 15.7s-1 4.5-1.65 4.5-1-.88-4.77-.88c-4.09 0-4.41 5-5.11 5-4.1-.03-18.87-3.36-18.87-15.11",
			style: { fill: "#fd8369" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M769.83 545.68a10 10 0 0 0-3.71.72 1.3 1.3 0 0 0-1-.53c-3.27 0-34.25-1.15-37.52-.58 5.39-4.61 16.74-16.55 16.74-16.55l-25.6-30.6c-5.77 2.12-47.53 44.27-47.53 59.66 0 14.25 18.09 16.36 31.18 16.36 16.21 0 41.45-4.08 55-8 1.32 7.36 6.39 12.85 12.45 12.85 7.07 0 12.8-7.45 12.8-16.64s-5.74-16.69-12.81-16.69",
			className: "notebook-man-cls-4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M779.13 474.15c16 17.74-27.92 66.75-35.86 66.75s-35.58-28.77-32.57-46.64 59.08-30.45 68.43-20.11",
			style: { fill: "#fed892" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m879.46 666.16-13.04 332.17h-27.69l-42.67-313.07",
			style: { fill: "#74d5de" }
		}),
		/* @__PURE__ */ _jsx("path", { d: "M865.21 1006.07v21.69h-63.59v-7.13l36.14-14.56zm55.46-56.99 14.93 9.01-16.4 61.44-6.89-1.84-6.02-48.97z" })
	]
});
export default Svg027DrawkitNotebookManColour;
